<template>
  <section class="pt-5 pb-5" :style="{ 'color': color, 'background-color': backgroundColor }">
    <b-container>
      <b-row>
        <lazy-transition name="slide">
          <b-col align="center">
            <h1 class="text-uppercase">{{ heading }}</h1>
            <slot></slot>
          </b-col>
        </lazy-transition>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "Feature",
  props: {
    heading: String,
    color: String,
    backgroundColor: String,
  },
};
</script>

<style scoped>
h1 {
  margin-bottom: 3rem;
  border-bottom: 0.25rem solid currentColor;
  display: inline-block;
  line-height: 4rem;
}

.slide-enter {
  opacity: 0;
  transform: translateX(3rem);
}

.slide-enter-to {
  opacity: 1;
}

.slide-enter-active {
  transition: all 1s ease;
}
</style>
